ScoreTrekBattle.Tournament.PointsMap = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        VERSION: '1.0'
    };

    function resetStatus() {
        STATUS = {
            active: false,
            isInline: false,
            viewHandler: null,
            viewDialog: null,
            loadedPointsMap: null,
            isUsedRunning: false,
            returnType: null,
            returnId: null,
            view: null,
            $view: null
        };
    }
    resetStatus();

    function onInline() {
        return new Promise(resolve => {
            STATUS.isInline = true;
            STATUS.viewHandler = {
                onShow: function(dialog) {
                    STATUS.viewDialog = dialog;
                    dialog.beforeClose(() => {
                        // TODO return false on unsaved changes
                        return true;
                    });
                }
            }
            resolve(STATUS.viewHandler);
        });
    }

    function onViewRenderCreate(returnType, returnId) {
        STATUS.loadedPointsMap = null;
        STATUS.returnType = returnType || null;
        STATUS.returnId = returnId || null;

        return onViewRender();
    }

    function onViewRenderEdit(pointsMapId, returnType, returnId) {
        if (pointsMapId === 'null') {
            return onViewRenderCreate(returnType, returnId);
        }

        STATUS.loadedPointsMap = null;
        STATUS.returnType = returnType || null;
        STATUS.returnId = returnId || null;

        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.PointsMap.onViewRenderEdit', true);
            Api.request('/battle/tournament/pointsMap/load', {id: pointsMapId}).then(result => {
                STATUS.loadedPointsMap = result.pointsMap;
                STATUS.isUsedRunning = result.isUsedRunning || false;
                onViewRender().then($view => {
                    resolve($view);
                });
            }).catch(error => {
                if (error && error.message) {
                    chmDialog.error(error);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.PointsMap.onViewRenderEdit', false);
            });
        });
    }

    function onViewRender() {
        return new Promise(function(resolve) {
            var buttonText;

            ScoreTrekBattle.View.updateMenu('/tournament/create');

            buttonText = STATUS.loadedPointsMap ? __i18n('button/savePointsMap') : __i18n('button/addPointsMap');

            ScoreTrekBattle.Template.render('tournament/pointsMap/edit', {
                introTitle: __i18n(`pointsMap/intro/${STATUS.loadedPointsMap ? 'edit' : 'create'}/title`, {button: buttonText}),
                introText: __i18n(`pointsMap/intro/${STATUS.loadedPointsMap ? 'edit' : 'create'}/text`, {button: buttonText}),
                buttonText: buttonText
            }).then(view => {
                STATUS.active = true;
                STATUS.view = view;
                STATUS.$view = view.$view;
                STATUS.$view.toggleClass('allowNameEdit', true);
                STATUS.$view.find('[data-id="pointsMapIsUsedRunningInfo"]').css('display', STATUS.isUsedRunning ? '' : 'none');

                setPointsMapName();
                setPointsMapValues();
                updateLabels();
                addEventListeners();
                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            if (STATUS.loadedPointsMap) {
                // TODO set fields
            }
            resolve();
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function onCheckAccess() {
        return ScoreTrekBattle.Session.isBattleManager();
    }

    function setPointsMapValues() {
        let map;

        map = getDefaultMap(STATUS.loadedPointsMap ? STATUS.loadedPointsMap.map : null);

        updateValues(map);
    }

    function getDefaultMap(map) {
        let i, key;

        if (!map) {
            map = {
                'starterPoints': 0
            };
        }

        for (i = 1; i <= 32; i++) {
            key = `points_${i}`;

            if (!map.hasOwnProperty(key)) {
                map[`points_${i}`] = 0;
            }
        }

        return map;
        
    }

    function addEventListeners() {
        let i, key;

        addControlEventListeners(STATUS.view.controls['starterPoints']);

        for (i = 1; i <= 32; i++) {
            key = `points_${i}`;
            addControlEventListeners(STATUS.view.controls[key]);
        }
    }

    function addControlEventListeners(control) {
        if (!control) {
            return;
        }

        control.on('focus', function() {
            if (this.get() === '0') {
                this.set('');
            }
        });

        control.on('blur', function() {
            if (this.get() === '') {
                this.set(0);
            }
        });

        control.on('input change', function() {
            let value;

            value = parseInt(this.get(), 10);

            if (isNaN(value) || (value < 0)) {
                value = 0;
            }

            if (value > 999) {
                value = 999;
            }

            if (String(value) !== String(this.get())) {
                this.set(value);
            }
        });
    }

    function updateLabels() {
        let i, key;

        for (i = 1; i <= 32; i++) {
            key = `points_${i}`;

            STATUS.view.controls[key].$get().closest('[data-control-id]').find('label').html(__i18n('form/field/pointsForPosition', {position: i}));
        }
    }

    function updateValues(map) {
        let i, key;

        setValue(STATUS.view.controls['starterPoints'], map['starterPoints'] || 0);

        for (i = 1; i <= 32; i++) {
            key = `points_${i}`;

            setValue(STATUS.view.controls[key], map[key] || 0);
        }
    }

    function setValue(control, value) {
        if (!control) {
            return;
        }

        control.set(value);
    }

    function getValues() {
        let i, key, map;

        map = {
            'starterPoints': getValue(STATUS.view.controls['starterPoints'])
        };

        for (i = 1; i <= 32; i++) {
            key = `points_${i}`;
            map[key] = getValue(STATUS.view.controls[key]);
        }

        return map;
    }

    function getValue(control) {
        if (!control) {
            return 0;
        }

        return parseInt(control.get(), 10);
    }

    function validatePointsMap() {
        let i, key, lastValue, value, errors;

        lastValue = -1;
        errors = [];

        for (i = 1; i <= 32; i++) {
            key = `points_${i}`;

            value = parseInt(STATUS.view.controls[key].get(), 10);

            if ((lastValue >= 0) && (isNaN(value) || (value > lastValue))) {
                errors.push({
                    field: key,
                    message: __i18n('pointsMap/error/mustBeLargerOrEqual', {higherPosition: i, lowerPosition: i - 1})
                });
            }

            lastValue = value;
        }

        STATUS.view.forms.pointsMap.errors(errors);

        return (errors.length === 0);
    }

    function setPointsMapName(pointsMapName, isDefaultName) {
        var $pointsMapName;

        if (!pointsMapName) {
            pointsMapName = STATUS.loadedPointsMap ? STATUS.loadedPointsMap.name : `<i>${__i18n(`pointsMap/defaultName`)}</i>`;
            isDefaultName = !STATUS.loadedPointsMap;
        }

        $pointsMapName = STATUS.$view.find('[data-id="pointsMapName"]');

        $pointsMapName.attr('data-is-default', isDefaultName ? 'yes' : 'no');

        $pointsMapName[isDefaultName ? 'html' : 'text'](pointsMapName);
    }

    function getPointsMapName() {
        return STATUS.$view.find('[data-id="pointsMapName"]').text();
    }

    function inputPointsMapName() {
        return new Promise(function(resolve, reject) {
            var $pointsMapName;
            $pointsMapName = STATUS.$view.find('[data-id="pointsMapName"]');

            if ($pointsMapName.attr('data-is-default') === 'yes') {
                editPointsMapName(generatePointsMapName()).then(pointsMapName => {
                    setPointsMapName(pointsMapName, true);
                    resolve(pointsMapName);
                }).catch(reject);
            } else {
                resolve(getPointsMapName());
            }

        });
    }

    function generatePointsMapName() {
        return `${__i18n(`pointsMap/defaultName`)}`;
    }

    function savePointsMap(pointsMapId) {
        if (!validatePointsMap()) {
            return;
        }

        inputPointsMapName().then(pointsMapName => {
            var pointsMapData;

            pointsMapData = {
                name: pointsMapName,
                version: CONFIG.VERSION,
                // TODO get values
                map: getValues()
            };

            if (pointsMapId) {
                pointsMapData.id = pointsMapId;
            }

            storePointsMap(pointsMapData, !STATUS.isInline).then(pointsMap => {
                if (pointsMap) {
                    if (pointsMapData.id) {
                        setPointsMapName(pointsMap.name);
                        STATUS.loadedPointsMap = pointsMap;
                    } 
                    
                    if (STATUS.isInline) {
                        STATUS.viewDialog.close().then(() => {
                            ScoreTrekBattle.Event.trigger('pointsMap.updated', pointsMap);
                        });
                        return;
                    }

                    if (STATUS.returnType === 'return:tournament.details') {
                        if (STATUS.returnId) {
                            ScoreTrekBattle.View.goto(`/tournament/details/${STATUS.returnId}`);
                        } else {
                            ScoreTrekBattle.View.goto(`/tournament/plan`);
                        }
                        return;
                    }

                    if (STATUS.returnType === 'return:tournament.edit') {
                        if (STATUS.returnId) {
                            ScoreTrekBattle.View.goto(`/tournament/edit/${STATUS.returnId}/${pointsMap.id}`);
                            return;
                        }
                    }

                    ScoreTrekBattle.View.goto(`/tournament/create`);
                }
            }).catch(ignore => {});
        }).catch(ignore => {});
    }

    function storePointsMap(pointsMapData, showConfirmation) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.PointsMap.storePointsMap', true);
            Api.request(`/battle/tournament/pointsMap/${pointsMapData.hasOwnProperty('id') ? 'update' : 'create'}`, {
                pointsMap: pointsMapData
            }).then(result => {
                if (result && result.done) {
                    if (showConfirmation !== false) {
                        chmDialog.success(__i18n(`pointsMap/${pointsMapData.hasOwnProperty('id') ? 'update' : 'create'}/done`), null, __i18n('button/ok')).then(() => {
                            resolve(result.pointsMap);
                        });
                    } else {
                        resolve(result.pointsMap);
                    }
                } else {
                    chmDialog.error(`pointsMap/${pointsMapData.hasOwnProperty('id') ? 'update' : 'create'}/failed`);
                    reject();
                }
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                AnimationHandler.scrollToTop(false, STATUS.$view);
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.PointsMap.storePointsMap', false);
            });
        });
    }

    function editPointsMapName(currentPointsMapName) {
        return new Promise(function(resolve, reject) {
            chmDialog.prompt({
                title: __i18n('dialog/pointsMap/name/title'),
                prompt: __i18n('dialog/pointsMap/name/prompt'),
                value: currentPointsMapName
            }).then(pointsMapName => {
                if (!pointsMapName) {
                    reject();
                    return;
                }
                resolve(pointsMapName);
            }).catch(reject);
        });
    }

    function deletePointsMap(pointsMapId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.PointsMap.deletePointsMap', true);
            Api.request('/battle/tournament/pointsMap/delete', {id: pointsMapId}).then(result => {
                resolve();
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.PointsMap.deletePointsMap', false);
            });
        });
    }

    function clonePointsMap(pointsMapId) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.PointsMap.clonePointsMap', true);
            Api.request('/battle/tournament/pointsMap/clone', {id: pointsMapId}).then(result => {
                resolve(result.pointsMapId);
            }).catch(result => {
                if (result.error && result.message) {
                    chmDialog.error(result);
                }
                if (result.thrownError) {
                    console.error(thrownError);
                }
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.PointsMap.clonePointsMap', false);
            });
        });
    }

    _this = {
        delete: function(pointsMapId) {
            return deletePointsMap(pointsMapId);
        },
        clone: function(pointsMapId) {
            return clonePointsMap(pointsMapId);
        },
        rename: function(pointsMapId, currentPointsMapName) {
            return new Promise(function(resolve, reject) {
                editPointsMapName(currentPointsMapName).then(pointsMapName => {
                    storePointsMap({
                        id: pointsMapId,
                        name: pointsMapName
                    }, null, false).then(pointsMap => {
                        resolve(pointsMap);
                    }).catch(reject);
                }).catch(reject);
            });
        }
    };

    ScoreTrekBattle.View.register('/tournament/pointsMap/create', onViewRenderCreate, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess, onInline);
    ScoreTrekBattle.View.register('/tournament/pointsMap/edit', onViewRenderEdit, onViewLoad, onViewUpdate, onViewUnload, onCheckAccess, onInline);

    ScoreTrekBattle.Event.on('action.pointsMap.save', function() {
        if (!STATUS.active) {
            return;
        }

        savePointsMap(STATUS.loadedPointsMap ? STATUS.loadedPointsMap.id : null);
    });

    ScoreTrekBattle.Event.on('action.pointsMap.autoFill', function(event, startPosition) {
        let value, i;

        if (!STATUS.active) {
            return;
        }

        startPosition = parseInt(startPosition, 10);

        value = getValue(STATUS.view.controls[`points_${startPosition}`]);

        for (i = startPosition + 1; i <= 32; i++) {
            setValue(STATUS.view.controls[`points_${i}`], value);
        }
    });

    ScoreTrekBattle.Event.on('action.pointsMap.rename', function() {
        if (!STATUS.active) {
            return;
        }

        if (STATUS.isUsedRunning) {
            _this.rename(STATUS.loadedPointsMap.id, getPointsMapName()).then(pointsMap => {
                setPointsMapName(preset.name);
                ScoreTrekBattle.Event.trigger('pointsMap.updated', pointsMap);                
            });

            return;
        }

        editPointsMapName(getPointsMapName()).then(pointsMapName => {
            setPointsMapName(pointsMapName);
        }).catch(ignore => {});
    });


    return _this;
})();